import { post, wordpost } from '../network/index.js'
//查询交易记录列表
const listTradingRecord = data => {
  return post('/mercWebi/tradingRecord/listTradingRecord', data)
}
//查询交易记录明细
const listTradingRecordByPayId = data => {
  return post('/mercWebi/tradingRecord/listTradingRecordByPayId', data)
}

//获取账号下所有的店铺
const queryOrderDetail = data => {
  return post('/mercWebi/busStoreInfo/queryOrderDetail', data)
}

//导出交易记录列表
const downOrderList = data => {
  return post('/mercWebi/tradingRecord/downloadTradingRecord', data)
}
//导出交易记录列表
const downOrderDealList = data => {
  return wordpost('/mercWebi/tradingRecord/downloadTradingRecord', data)
}
//导出优卡使用记录
const downloadBillList = data => {
  return wordpost('/mercWebi/userCard/downloadBillList', data)
}
//导出优卡充值
const excelBillList = data => {
  return wordpost('/mercWebi/userCard/excelBillList', data)
}
//导出商品订单列表
const downloadProductOrders = data => {
  return wordpost('/mercWebi/order/downloadProductOrders', data)
}
//导出所有优卡
const downloadCardList = data => {
  return wordpost('/mercWebi/userCard/downloadCardList', data)
}
//导出优卡使用记录
const downCardloadBillList = data => {
  return post('/mercWebi/userCard/downloadCardList', data)
}
//优卡 - 获取优卡对象
const listCardAnalysisByParam = data => {
  return post('/mercWebi/analysisReport/listCardAnalysisByParam', data)
}
// 订单交易 - 获取订单交易对象
const listOrderAnalysisByParam = data => {
  return post('/mercWebi/analysisReport/listOrderAnalysisByParam', data)
}
// 支付方式 - 获取支付方式对象
const listPayAnalysisByParam = data => {
  return post('/mercWebi/analysisReport/listPayAnalysisByParam', data)
}
// 退款列表
const getRefundList = data => {
  return post('/mercWebi/orderRefund/getRefundList', data)
}
// 退款详情
const getRefundDetail = data => {
  return post('/mercWebi/orderRefund/getRefundDetail', data)
}
// 退款导出
const exportRefundList = data => {
  return wordpost('/mercWebi/orderRefund/exportRefundList', data)
}
//衣物管理导出
const exportWashList = data => {
  return wordpost('/mercWebi/washOrder/exportWashList', data)
}
// 提现列表
const cashoutList = data => {
  return post('/recovery-withdraw/page', data)
}
// 提现
const cashoutDoWithdraw = data => {
  return post('/recovery-withdraw/do-withdraw', data)
}
// 提现-撤销
const revokeWithdraw = data => {
  return post('/mercWebi/accountAsset/cancelTransfer', data)
}
//数据统计-日报表
const daysReport = data => {
  return post('/mercWebi/analysisReport/daysReport', data)
}
//分佣-提现记录列表
const getWithInfoList = data => {
  return post('/mercWebi/accountAsset/getWithInfoList', data)
}
//分佣-银行转账
const confirmBlank = data => {
  return post('/mercWebi/accountAsset/confirmBlank', data)
}

//交易记录-跨店消费
const listUserCardBill = data => {
  return post('/mercWebi/tradingRecord/listUserCardBill', data)
}
//交易记录-跨店消费导出
const downloadUserCardBill = data => {
  return wordpost('/mercWebi/tradingRecord/downloadUserCardBill', data)
}

//财务统计-现款收入接口
const listCashTrading = data => {
  return post('/mercWebi/tradingReport/listCashTrading', data)
}
//财务统计-订单统计接口
const listOrderTrading = data => {
  return post('/mercWebi/tradingReport/listOrderTrading', data)
}
//财务统计-单品统计接口
const listGoodsCount = data => {
  return post('/mercWebi/tradingReport/listGoodsCount', data)
}
//财务统计-售卡统计接口
const listCardCount = data => {
  return post('/mercWebi/tradingReport/listCardCount', data)
}
//财务统计-售券统计接口
const listCouponCount = data => {
  return post('/mercWebi/tradingReport/listCouponCount', data)
}
//财务统计-优卡剩余余额统计
const mercGiftCardCount = data => {
  return post('/mercWebi/tradingReport/mercGiftCardCount', data)
}

//服务订购-查询商家软件分
const queryMercScore = data => {
  return post('/mercWebi/softScore/queryMercScore', data)
}
//服务订购-软件分购买记录
const purchaseRecord = data => {
  return post('/mercWebi/softScore/purchaseRecord', data)
}
//服务订购-查询软件分使用明细
const softScoreDetail = data => {
  return post('/mercWebi/softScore/softScoreDetail', data)
}

// 用户列表-导出
const downloadUserList = data => {
  return wordpost('/mercWebi/userInfo/listExport', data)
}

// 积分记录列表-导出
const downIntegralList = data => {
  return wordpost('/integralMange/integralExport', data)
}

// 伙伴分成记录列表-导出
const partnerCommissionExport = data => {
  return wordpost('/mercWebi/storePartner/partnerCommissionExport', data)
}

// 分佣记录-导出
const orderCommissionExport = data => {
  return wordpost('/mercWebi/teamLeader/orderCommissionExport', data)
}

// 分佣提现记录-导出
const accountAssetExport = data => {
  return wordpost('/mercWebi/accountAsset/accountAssetExport', data)
}

// 领券记录-导出
const couponIssueExport = data => {
  return wordpost('/mercWebi/userInfo/couponIssueExport', data)
}

export default {
  queryOrderDetail,
  listTradingRecord,
  listTradingRecordByPayId,
  downOrderList,
  downOrderDealList,
  downloadBillList,
  excelBillList,
  downloadProductOrders,
  downloadCardList,
  downCardloadBillList,
  listCardAnalysisByParam,
  listOrderAnalysisByParam,
  listPayAnalysisByParam,
  cashoutList,
  getRefundList,
  cashoutDoWithdraw,
  getRefundDetail,
  exportRefundList,
  exportWashList,
  daysReport,
  cashoutList,
  cashoutDoWithdraw,
  getWithInfoList,
  revokeWithdraw,
  confirmBlank,
  listUserCardBill,
  downloadUserCardBill,
  listCashTrading,
  listOrderTrading,
  listGoodsCount,
  listCardCount,
  listCouponCount,
  mercGiftCardCount,
  queryMercScore,
  purchaseRecord,
  softScoreDetail,
  downloadUserList,
  downIntegralList,
  partnerCommissionExport,
  orderCommissionExport,
  accountAssetExport,
  couponIssueExport
}
